import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { ReportService } from '../services/report.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-unsettle-bet',
  templateUrl: './unsettle-bet.component.html',
  styleUrls: ['./unsettle-bet.component.scss']
})
export class UnsettleBetComponent implements OnInit {

  public Base_Url = environment['adminServerUrl'];
  moment: any = moment;
  itemsPerPage: number = 100;
  currentPage: number = 1;
  totalItems: number = 0;
  settleBetFilter: boolean = false;
  settledBetData: any = [];
  public token = localStorage.getItem('userAccessToken');
  reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ` + this.token
  });
  router: any;
  constructor(private http: HttpClient,private reportService :ReportService,private toastr: ToastrService) { }

  ngOnInit(): void {
    this.openBets()
  }
  pageChange(event?: any) {
    if (event) {
      this.currentPage = event
    }else{
      this.currentPage=1
    }
      this.openBets('filterBtnClick');
  }

  openBets(from?: string) {
    let data = {
      page: this.currentPage,
      limit: this.itemsPerPage,
    }
    this.reportService.openBets(data).subscribe((res) => {
      if (res.status) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
        this.settledBetData = res.data[0].data;
        this.settleBetFilter = false;
        this.totalItems = res.data[0]?.metadata[0]?.total
        this.currentPage = res.data[0]?.metadata[0]?.page
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
        this.settledBetData=[]
      }
    })


  }

}
